
import React from "react";
import NotificationViewForm from "./NotificationViewForm";
import NotificationEditForm from "./NotificationEditForm";
import { Notification } from "@/hooks/useNotificationDetail";
import { AIAnalysisResult } from "@/types/notifications";

interface NotificationFormProps {
  notification: Notification;
  editMode: boolean;
  editedNotification: Notification | null;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  isAnalyzing: boolean;
  setIsAnalyzing: (isAnalyzing: boolean) => void;
  onAnalysisComplete: (data: AIAnalysisResult) => void;
}

const NotificationForm = ({
  notification,
  editMode,
  editedNotification,
  handleInputChange,
  isAnalyzing,
  setIsAnalyzing,
  onAnalysisComplete
}: NotificationFormProps) => {
  if (editMode) {
    return (
      <NotificationEditForm
        notification={notification}
        editedNotification={editedNotification}
        handleInputChange={handleInputChange}
        isAnalyzing={isAnalyzing}
        setIsAnalyzing={setIsAnalyzing}
        onAnalysisComplete={onAnalysisComplete}
      />
    );
  }

  return <NotificationViewForm notification={notification} />;
};

export default NotificationForm;
